export const panelSx = {
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 3,
  boxShadow: "none",
  bgcolor: "background.paper",
};
export const focusSx = {
  "&:focus-visible": { outline: "3px solid", outlineColor: "info.main", outlineOffset: 4 },
};
